import { StreamActions, StreamElement } from '@hotwired/turbo'
import SnackBarController from '../../stimulus/controllers/snack-bar'

StreamActions.add_snack = function (this: StreamElement) {
  const message = this.getAttribute('message')

  if (!message) {
    return console.warn('The `add_snack` Turbo Stream action could not add a snack. No message was provided.')
  }

  const snackBarElement = document.querySelector('[data-controller*=snack-bar]')

  if (!snackBarElement) {
    return console.warn(
      'The `add_snack` Turbo Stream action could not add a snack. The Snack Bar element could not be found.',
    )
  }

  const snackBar = window.Stimulus.getControllerForElementAndIdentifier(
    snackBarElement,
    'snack-bar',
  ) as SnackBarController

  if (!snackBar) {
    return console.warn(
      'The `add_snack` Turbo Stream action could not add a snack. The Snack Bar element is not registered as a Stimulus `SnackBarController`.',
    )
  }

  snackBar.add(message)
}
